import React, { Ref } from 'react';

import { Icon } from '@rbilabs/components-library';
import { useIntl } from 'react-intl';

import Currency from 'components/currency';
import { useUIContext } from 'state/ui';

import { FloatingLink, IconWrap } from './styled';

export interface ICheckoutButtonLink {
  ref: Ref<HTMLAnchorElement>;
  amount: number;
  to: string;
  logMobileCheckoutEvent: () => void;
}

const CheckoutButtonLink = ({ amount, to, logMobileCheckoutEvent, ref }: ICheckoutButtonLink) => {
  const { appFooterDimensions, bottomServiceDimensions } = useUIContext();

  const { formatMessage } = useIntl();

  return (
    <FloatingLink
      $bottomInset={appFooterDimensions.height + bottomServiceDimensions.height}
      data-testid="cart-button-mobile"
      aria-label={formatMessage({ id: 'checkout' })}
      onClick={logMobileCheckoutEvent}
      to={to}
      ref={ref}
    >
      <IconWrap>
        <Icon icon="cart" color="icon-button-secondary" width="16px" aria-hidden />
      </IconWrap>
      <Currency amount={amount} />
    </FloatingLink>
  );
};

export default CheckoutButtonLink;
